<template>
  <el-popover placement="bottom-end" width="220" trigger="click" popper-class="theme-switcher-popover">
    <div class="theme-panel">
      <div class="theme-panel-title">Theme Colors</div>
      <div class="theme-list">
        <button
          v-for="t in themes"
          :key="t.id"
          type="button"
          class="theme-item"
          :class="{ active: currentId === t.id }"
          @click="pick(t.id)"
        >
          <span class="theme-dot" :style="{ background: t.primary }"></span>
          <span class="theme-name">{{ t.name }}</span>
          <i v-if="currentId === t.id" class="el-icon-check theme-check"></i>
        </button>
      </div>
    </div>
    <i slot="reference" class="el-icon-brush header-icon" title="Switch Theme"></i>
  </el-popover>
</template>

<script>
import { THEMES } from '@/config/theme'
import { applyTheme, getStoredThemeId } from '@/utils/applyTheme'

export default {
  name: 'ThemeSwitcher',
  data() {
    return {
      themes: THEMES,
      currentId: getStoredThemeId()
    }
  },
  methods: {
    pick(id) {
      const theme = applyTheme(id)
      this.currentId = id
      this.$message.success(`Theme switched to ${theme.name}`)
    }
  }
}
</script>

<style scoped>
.theme-panel-title {
  font-size: 13px;
  font-weight: 600;
  color: #1d2129;
  margin-bottom: 8px;
}
.theme-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.theme-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  border: 1px solid transparent;
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  cursor: pointer;
}
.theme-item:hover {
  background: #f7f8fa;
}
.theme-item.active {
  border-color: var(--hrs-primary);
  background: var(--hrs-primary-light);
}
.theme-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
}
.theme-name {
  flex: 1;
  text-align: left;
  font-size: 13px;
  color: #1d2129;
}
.theme-check {
  color: var(--hrs-primary);
}
.header-icon {
  font-size: 18px;
  color: #4e5969;
  cursor: pointer;
  transition: color 0.15s;
}
.header-icon:hover {
  color: var(--hrs-primary);
}
</style>
